// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2TWQO","name":"ConsentHeader_name__Kgt6j","birthday":"ConsentHeader_birthday__1V6mZ","skeleton":"ConsentHeader_skeleton__3IBSi"};